module.exports = __webpack_public_path__ + "img/artist2.b401b2ea.jpeg";